import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { SolutionsHero } from "@/components/solutions/SolutionsHero";
import { SolutionsIntro } from "@/components/solutions/SolutionsIntro";
import { SolutionsList } from "@/components/solutions/SolutionsList";
import { SolutionsDelivery } from "@/components/solutions/SolutionsDelivery";
import { SolutionsCTA } from "@/components/solutions/SolutionsCTA";

export default function Solutions() {
  useEffect(() => {
    window.lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="solutions-page" className="bg-baseLight min-h-screen">
      <Navbar />
      <SolutionsHero />
      <SolutionsIntro />
      <SolutionsList />
      <SolutionsDelivery />
      <SolutionsCTA />
      <Footer />
    </div>
  );
}
